export function convertRichTextToHTML(richTextJSON) {
  if (!richTextJSON) return "";

  const parsed = JSON.parse(richTextJSON.replace(/\\n/g, "<br>"));

  const parsedText = (node) => {
    let text = node.value || "";
    text = text.replace(/<br>/g, "<br>");

    if (node.bold) text = `<strong>${text}</strong>`;
    if (node.italic) text = `<em>${text}</em>`;

    return text;
  };

  const processNode = (node) => {
    switch (node.type) {
      case "root":
        return node.children.map(processNode).join("");

      case "paragraph":
        return `<p>${node.children.map(processNode).join("")}</p>`;

      case "text":
        return parsedText(node);

      case "heading":
        return `<h${node.level}>${node.children.map(processNode).join("")}</h${node.level}>`;

      default:
        return node.children ? node.children.map(processNode).join("") : "";
    }
  };

  const richText = processNode(parsed);

  const wrapper =
    richText.substring(0, 1) === "<"
      ? richText.substring(1).split(">")[0]
      : "div";
  let content = richText;

  if (wrapper !== "") {
    const open = new RegExp(`^<${wrapper}>`);
    const close = new RegExp(`</${wrapper}$`);
    content = richText.replace(open, "").replace(close, "");
  }

  return {
    wrapper,
    content,
  };
}
